import { useClientTips } from '@ukpostbox/client-data';
import { ContentBlock, ContentLoader, useTranslation } from '@ukpostbox/frontend-framework';
import { useAuthorisedUser } from '../../_Auth/Providers/AuthProvider';
import Carousel from '../../_Global/Components/Carousel/Carousel';
import { AccountTipsBlockType } from './AccountTipsType';
import { AccountTipEntry } from './AccountTipEntry';

function MapTips(props: AccountTipsBlockType) {
	const { t } = useTranslation();
	const { data, status, error } = useClientTips();

	return status === 'pending' ? (
		<ContentLoader round childHeight='15em' childCount={1} />
	) : status === 'error' ? (
		<ContentBlock error stacked title={error.name} content={error.message} />
	) : (
		<Carousel
			isOpen
			title={props.title || t('labels.tips')}
			items={data
				.sort(() => Math.random() - 0.5)
				.map((item) => (
					<AccountTipEntry {...item} />
				))}
		/>
	);
}

function AccountTipsBlock(props: AccountTipsBlockType) {
	const { token } = useAuthorisedUser();

	if (!token) return null;

	return <MapTips {...props} />;
}

export default AccountTipsBlock;
